module.exports = __webpack_public_path__ + "static/media/J.b252ee0e.svg";